import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, AsyncPipe } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Observable } from 'rxjs';

import { PlayerDetailStateService } from '../../features/statistics/controller/player-detail-state.service';
import { PlayerDetailHeaderComponent } from '../../features/statistics/view/player-detail-header/player-detail-header.component';
import { PlayerStatsDashboardComponent } from '../../features/statistics/view/player-stats-dashboard/player-stats-dashboard.component';
import { Player, PlayerSeasonStatsDTO, Season } from '@solverml/api';

/**
 * Página "Smart" para la vista de detalle de un jugador.
 * Orquesta los componentes "Dumb" (Header, Dashboard) y
 * se comunica con el "Cerebro" (PlayerDetailStateService).
 */
@Component({
  selector: 'app-player-detail-page',
  standalone: true,
  imports: [
    CommonModule,
    AsyncPipe,
    RouterLink,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    PlayerDetailHeaderComponent,
    PlayerStatsDashboardComponent
  ],
  templateUrl: './player-detail-page.component.html',
  styleUrls: ['./player-detail-page.component.scss'],
  /**
   * Proveemos el StateService A NIVEL DE COMPONENTE.
   * Esto asegura que el estado se crea cuando se navega a esta página
   * y se destruye (con OnDestroy) cuando se sale de ella.
   */
  providers: [PlayerDetailStateService]
})
export class PlayerDetailPageComponent implements OnInit, OnDestroy {

  // Inyección de dependencias moderna
  private state = inject(PlayerDetailStateService);
  private route = inject(ActivatedRoute);

  // Observables públicos para el template (conectados al state)
  public isLoading$: Observable<boolean>;
  public isLoadingStats$: Observable<boolean>;
  public playerProfile$: Observable<Player | null>;
  public playerSeasons$: Observable<Season[] | null>;
  public selectedSeasonStats$: Observable<PlayerSeasonStatsDTO | null>;

  constructor() {
    this.isLoading$ = this.state.isLoading$;
    this.isLoadingStats$ = this.state.isLoadingStats$;
    this.playerProfile$ = this.state.playerProfile$;
    this.playerSeasons$ = this.state.playerSeasons$;
    this.selectedSeasonStats$ = this.state.selectedSeasonStats$;
  }

  ngOnInit(): void {
    // 1. Obtener el ID del jugador de la ruta
    const playerId = this.route.snapshot.paramMap.get('id');

    // 2. Si tenemos ID, cargar los datos
    if (playerId) {
      this.state.loadData(playerId);
    } else {
      console.error("No player ID found in route");
    }
  }

  ngOnDestroy(): void {
    // 3. Resetear el estado al salir de la página
    this.state.resetState();
  }

  /**
   * Se dispara desde el (Output) del dashboard
   * @param seasonId El ID de la nueva temporada seleccionada
   */
  public onSeasonChange(seasonId: number): void {
    this.state.changeSeason(seasonId);
  }
}
